// import { transformCloudinaryImage } from "../../utils/cloudinary";
// const BestsellerSection = ({ title, products }) => {
//   if (!products || !products.length) return null;

//   return (
//     // 🌈 FULL WIDTH BACKGROUND
//     <section className="w-full py-16 bestseller-gradient">
      
//       {/* 🔒 CONTENT CONTAINER */}
//       <div className="max-w-6xl mx-auto px-6">
        
//         <h2 className="text-center text-white text-3xl font-semibold mb-12">
//           {title}
//         </h2>

//         {/* 🧱 GRID instead of flex-center */}
//         <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-12 place-items-center mb-14">
//           {products.map((item) => (
//            <div
//   key={item._id}
//   className="w-[280px] h-[420px] rounded-2xl 
//              bg-white/25 backdrop-blur-md 
//              shadow-xl overflow-hidden"
// >
//   {/* src={transformCloudinaryImage(item.images?.[0])} */}
//   {/* IMAGE WRAPPER */}
//   <div className="w-full h-full flex items-center justify-center p-4">
//     <img
//       src={item.images?.[0]}
//       alt={item.productName}
//       className="max-h-full max-w-full object-contain"
//     />
//   </div>
// </div>



          
//           ))}
//         </div>

//         {/* 🔘 BUTTON */}
//         <div className="flex justify-center">
//           <button className="bg-[#B2703D] hover:bg-[#9C5F33] transition text-white px-12 py-3 rounded-lg tracking-wide">
//             SHOP ALL
//           </button>
//         </div>

//       </div>
//     </section>
//   );
// };

// export default BestsellerSection;
import { useNavigate } from "react-router-dom";

const BestsellerSection = ({ title, products }) => {
  const navigate = useNavigate();

  if (!products || !products.length) return null;


  return (
    <section className="w-full py-16 bestseller-gradient">
      <div className="max-w-6xl mx-auto px-6">

        <h2 className="text-center text-white text-3xl font-semibold mb-12">
          {title}
        </h2>

        {/* PRODUCTS */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-12 place-items-center mb-14">
          {products.map((item) => (
            <div
              key={item._id}
              className="w-full h-full rounded-2xl bg-white/25 backdrop-blur-md shadow-xl overflow-hidden"
            >
            {/* <div className="w-[280px] h-[420px] rounded-2xl bg-white/25 backdrop-blur-md shadow-xl overflow-hidden"> */}
              <div className="w-full h-full">
                <img
                  src={item.images?.[0]}
                  alt={item.productName}
                  className="w-full h-full object-fill"
                />
              {/* </div> */}
            </div>

            </div>
          ))}
        </div>

        {/* SHOP ALL */}
        <div className="flex justify-center">
          <button
            onClick={() =>
              navigate(
                `/all-userproducts?bestSeller=1`
              )
            }
            className="bg-[#B2703D] hover:bg-[#9C5F33] transition text-white px-12 py-3 rounded-lg tracking-wide"
          >
            SHOP ALL
          </button>
        </div>

      </div>
    </section>
  );
};

export default BestsellerSection;

